module.exports = __webpack_public_path__ + "img/event-lobby.58810260.svg";